import { FC, MouseEvent, useCallback, useContext, useState } from 'react';
import { PDF_CONTENT_REF, PDF_FOOTER_REF, PDF_HEADER_REF } from 'common/constants/domRefs';
import { useStore } from 'common/store';
import { PdfReportFooter, PdfReportHeader, TabsNavigation } from 'components';
import LayoutContext from 'context/LayoutContext';
import { FirmPendingDecisions, NoCompanyMessage, NoInformationMessage } from 'pages/Firms/components';
import { useFirmSummaryTab } from 'pages/Firms/hooks';
import { getObjectValue } from 'utilities';

const FirmSummary: FC = () => {
  // Create firm summary tab
  const { firmSummaryTab, hasNoCompanies, hasNoInvestments } = useFirmSummaryTab();
  const [currentTabMenu, setCurrentTabMenu] = useState<HTMLSpanElement | null>(null);

  // Get firm name from store
  const [storeValue] = useStore();
  const { firmInfo: currentFirm } = getObjectValue(storeValue);
  const { name: firmName } = getObjectValue(currentFirm);

  const { isExportMode } = useContext(LayoutContext) as { isExportMode: boolean };

  const handleMenuClose = useCallback(() => setCurrentTabMenu(null), []);
  const handleMenuOpen = useCallback(
    (event: MouseEvent<HTMLSpanElement>) => setCurrentTabMenu(event.currentTarget),
    []
  );

  return (
    <>
      <PdfReportHeader reportOnly={!isExportMode} title={firmName} data-ref={PDF_HEADER_REF} />
      <div data-ref={PDF_CONTENT_REF}>
        <TabsNavigation
          fullWidth
          handleMenuClose={handleMenuClose}
          handleMenuOpen={handleMenuOpen}
          menuAnchorEl={currentTabMenu}
          mountOnActive
          tabs={[firmSummaryTab]}
          updateUrlOnTabChange>
          {/* Pending decisions */}
          <FirmPendingDecisions />

          {/* Add company message */}
          {hasNoCompanies && <NoCompanyMessage />}

          {/* Add investment message */}
          {!hasNoCompanies && hasNoInvestments && <NoInformationMessage />}
        </TabsNavigation>
      </div>
      <PdfReportFooter reportOnly={!isExportMode} data-ref={PDF_FOOTER_REF} />
    </>
  );
};

export default FirmSummary;
